import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const taskListImporterSelectors = importerSelectors(
  'taskList.importer',
)

export default taskListImporterSelectors
